import React from 'react'
import { Parallax } from 'react-parallax'
import { getURLByRouteName } from '../../../utils/routes'

import arrow from '../../../assets/images/svg_icons/arrow.svg'
import logo from '../../../assets/images/title-icons/Eye-Line.svg'
import { Link } from 'react-router-dom'

const BusinessAreas = props => {
  const { texts } = props
  const { bussinessArea } = props.data

  return <Parallax renderLayer={percent => {
    let opacity = percent

    percent = Math.floor(percent * 100) + 10

    return <div className='home__business' style={{ opacity }}>
      <div className='home__business-header'>
        <div className='gray-line opacity-0' />
        <img src={logo} className='title-logo transition' alt='page icon' />
        <h2>{bussinessArea.title}</h2>
        <div className='home__business-paragraphs gray-color' dangerouslySetInnerHTML={{ __html: bussinessArea.paragraphs }} />
      </div>
      <div className='home__business-container'>
        <div className='home__business-item'>
          <div className='home__business-item-cover'
            style={{
              background: `url(${bussinessArea.products.banner})`,
            }}>
            <video autoPlay loop playsInline muted>
              <source src={bussinessArea.products.video} />
            </video>
            <Link to={getURLByRouteName('freeSale')} className='home__about-block centered'>
              <div className='home__business-item-container transition'>
                <div className='gray-line-vertical opacity-0' />
                <h2>{bussinessArea.products.title}</h2>
                <div className='gray-line-vertical' />
              </div>
            </Link>
          </div>
          <Link to={getURLByRouteName('construction')} className='home__about-block centered'>
            <span>{texts.readMore}</span>
            <img className='arrow-left' src={arrow} alt='flecha' />
          </Link>
        </div>
        <div className='home__business-item'>
          <div className='home__business-item-cover'
            style={{
              background: `url(${bussinessArea.prescription.banner})`,
            }}>
            <video autoPlay loop playsInline muted>
              <source src={bussinessArea.prescription.video} />
            </video>
            <Link to={getURLByRouteName('prescription')} className='home__about-block centered'>
              <div className='home__business-item-container transition'>
                <div className='gray-line-vertical opacity-0' />
                <h2>{bussinessArea.prescription.title}</h2>
                <div className='gray-line-vertical' />
              </div>
            </Link>
          </div>
          <Link to={getURLByRouteName('prescription')} className='home__about-block centered'>
            <span>{texts.readMore}</span>
            <img className='arrow-left' src={arrow} alt='flecha' />
          </Link>
        </div>
        <div className='home__business-item'>
          <div className='home__business-item-cover'
            style={{
              background: `url(${bussinessArea.animal_health.banner})`,
            }}>
            <video autoPlay loop playsInline muted>
              <source src={bussinessArea.animal_health.video} />
            </video>
            <Link to={getURLByRouteName('animalHealth')} className='home__about-block centered'>
              <div className='home__business-item-container transition'>
                <div className='gray-line-vertical opacity-0' />
                <h2>{bussinessArea.animal_health.title}</h2>
                <div className='gray-line-vertical' />
              </div>
            </Link>
          </div>
          <Link to={getURLByRouteName('animalHealth')} className='home__about-block centered'>
            <span>{texts.readMore}</span>
            <img className='arrow-left' src={arrow} alt='flecha' />
          </Link>
        </div>
      </div>
    </div>
  }}
  />
}

export default BusinessAreas